import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WithRender from  './zesaCheckOut.html';
import { IZesa } from '@/Models/IZesa';
import config from '@/settings/config.js';
import { LocalStorageService } from '@/services/LocalStorageService';
import { IInitiateGenericPaymentDto } from '@/Dtos/InitiateGenericPaymentDto';
import { IInitiatePaymentResponseDto } from '@/Dtos/InitiatePaymentResponseDto';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading
  }})
export default class zesaCheckout extends Vue {
  isLoading=false;
  fullPage = true;
  ShowCouponBox = false;
  paymentMethod="wallet";
  zesaModel: IZesa = {} as IZesa;
  payment: IInitiatePaymentResponseDto = {} as IInitiatePaymentResponseDto;
  localStorageService: LocalStorageService;
  initiatePaymentDto: IInitiateGenericPaymentDto;
  showPaymentMethods = !config.isMobile;
  balance=0;
  currency!: string;
 
  constructor()
  {
    super();
    this.localStorageService = new LocalStorageService();
    let zesa = this.localStorageService.get('zesa');
    if( zesa ===null || zesa ==="")
      this.$router.push("zesa");
    this.zesaModel =  JSON.parse(zesa);

    this.initiatePaymentDto =
    { 
      itemName : "Electricity",
      rateKey: this.zesaModel.key,
      itemDescription: this.zesaModel.meterNumber,
      portfolio: "zesa",
      recepientMobile: this.zesaModel.recepientNumber,
      senderMobile: this.zesaModel.senderNumber,
      signingParty:"",
      salesCurrencyAmount: this.zesaModel.salesCurrencyAmount
    };
  }
  
  mounted(){
    this.getCreditBalance();
  }

  getCreditBalance(): void {
    _axios.get(config.credits + "Currency="+ this.currency)
      .then(response => {
        this.balance = response.data.balance;
        this.currency = response.data.currency;
      })
      .catch(err => { console.error(err); })
      .finally(() => this.isLoading = false);
  }

  GetPaymetURL()
  {
    if(this.payment==null)
      return;
    return this.payment.payfasturl + this.paymentMethod;
  }
 

  initiatePayment()
  {
    if(this.paymentMethod === "wallet")
    this.initiatePaymentDto.signingParty = "wallet"
    else
    this.initiatePaymentDto.signingParty = "payfast"

    this.isLoading=true;
    _axios.post(config.gateway + "payment/Payment/v2/InitiatePayment" ,this.initiatePaymentDto)
    .then(response=>
      {
        this.loadInitiatePaymentResponse(response.data);
      })
      .then(res=>this.submitForPayment())
      .catch(err=>{console.error(err);})
      .finally(()=>this.isLoading=false);
  }

  private loadInitiatePaymentResponse (value:IInitiatePaymentResponseDto):void
  {
    this.localStorageService.add('paymentDetails',JSON.stringify(value));
    this.payment = value;
  }

  private submitForPayment():void
  {
    if (this.paymentMethod === "wallet")
      this.$router.push("Wallet");
    else
      (<HTMLFormElement>document.querySelector("#payfast")).submit();
  }
}